'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TableHeader = require('./components/TableHeader.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TableHeader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-table/lib/components/table-header/index.js
// module id = 1352
// module chunks = 1